export const ACCOUNTS_REQUEST_QUERY = "accounts";
export const BOOKS_REQUEST_QUERY = "books";
export const CURRENCIES_REQUEST_QUERY = "currencies";
export const SEARCH_CURRENCIES_REQUEST_QUERY = "search_currencies";
export const CONNECT_TRADE_REQUEST_QUERY = "connect-trade";
export const REFERESH_ACCESS_TOKEN_QUERY = "refresh_access_token";
export const FIAT_DEPOSIT_STATUS_QUERY = "fiat_deposit_status";

export const PROFILES_QUERY = "profiles";

export const CUSTOMERS_QUERY = "customers";

export const BUSINESS_ONLY_QUERIES = [
  CUSTOMERS_QUERY,
  "get-business-verification-sections",
  "customer",
];

export const PERSONAL_ONLY_QUERIES = ["invites"];
